<template>
  <div class="ma-4">
   <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
    <v-data-table
      :headers="headers"
      :items="trainings"
      sort-by="Training"
      sort-asc
      class="elevation-1"
      :loading="isLoading"
      loading-text="Loading Trainings"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Training</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            label="search"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="75%">
            <template v-slot:activator="{ on }">
              <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()"
                >
                <v-icon left>add</v-icon>
                Add Training</v-btn
              >
            </template>
            <v-card>
              <v-card-title style="background-color: #2b3990">
                <span class="headline white--text">{{ titleForm  }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field
                        v-model="newTraining"
                        label="Training Title"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field
                        v-model="newLink"
                        label="Youtube Link to Training Content"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-textarea
                        v-model="newDescription"
                        label="Description of Training"
                        outlined
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-file-input
                        v-model="newDocument"
                        label="Select PDF to upload"
                        show-size
                        filled
                        prepend-icon="mdi-camera"
                        accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        @change="fileSelected"
                        multiple
                      >
                        <template #selection="{ text, index }">
                          <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                        </template>
                      </v-file-input>
                    </v-col>
                      <v-col cols="12" sm="12" md="12"
                             v-for="document in newDocument" :key="document.url">
                          <template v-if="document.type === 'pdf'">
                              <LoadPDF :pdfFile="document.url"
                                       :pdfName="document.name"/>
                          </template>
                          <template
                              v-else-if="['jpg', 'jpeg', 'png'].includes(document.type)">
                              <img :src="document.url" alt="" width="320"
                                   height="240">
                          </template>
                          <template
                              v-else-if="['doc', 'docx'].includes(document.type)">
                              <a :href="document.url" target="_blank" download>Download
                                  Document</a>
                          </template>
                      </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        class="ma-2"
                        v-model="newCategory"
                        label="Category"
                        :items="categories"
                      ></v-select>
                    </v-col>

                    <iframe v-if="isPDF" id="pdf" style="width: 90%; height: 600px;"></iframe>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#259647" class="white--text" @click="addTraining()" v-if="newGlobTraining">Save</v-btn
                >
                <v-btn color="blue darken-1" text @click="updateTraining()" v-if="editTraining">Update</v-btn
                >
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>

      </template>

     <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="viewTraining(item)">
          mdi-eye
        </v-icon>

        <v-icon small @click="deleteTraining(item)">
          mdi-delete
        </v-icon>

      </template>
      <template v-slot:no-data>
        <v-btn color="#2b3990" class="white--text" @click="getTrainings()">Reset</v-btn>
      </template>
    </v-data-table>
    <Foot/>
  </div>
</template>

<script>

/*eslint-disable */
import axios from 'axios'
import Foot from '../components/Footer'
import { PDFDocument } from "pdf-lib";
import LoadPDF from "@/components/LoadPDF.vue";

const url = require("../client_config/config").url;

export default {
  components: {
      LoadPDF,
      Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Training',
          align: 'start',
          sortable: false,
          value: 'Training',
        },
        { text: "Youtube Link", value: "Link" },
        { text: "Description", value: "Description" },
        { text: "Category", value: "Category" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      categories: [
        "Monthly Training",
        "Staff Training",
        "DIY",
        "Policies & Procedures",
        "Protocols",
        "Common Forms"],
      dialog: false,
      editTraining: false,
      newGlobTraining: false,
      msg: false,
      search: "",
      text:"",
      trainings: [],
      titleForm: "New Training",
      trainingID: "",
      newTraining: "",
      newLink: "",
      newDescription: "",
      newCategory: "",
      newDocument: [],
      uploadFile: null,
      isPDF: false,
      editedIndex: -1,
      editedItem: {
        training: "",
        link: "",

      },
      defaultItem: {
        training: "",
        link: "",

      },
      isLoading: true,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.getTrainings();
  },

  methods: {
    initialize() {
      this.trainings = [];
    },
    viewTraining(item) {
      this.titleForm= "Viewing " + item.Training;
      this.dialog = true;
      this.editTraining = true;
      this.newGlobTraining = false;
      this.newTraining= item.Training;
      this.newLink= item.Link;
      this.newDescription = item.Description;
      this.newCategory = item.Category;
      this.trainingID= item._id;

        if ( item.documents && item.documents.length) {
            this.newDocument = item.documents.map(document => {
                return {
                    name: document.Name,
                    url: document.AWSLink,
                    type: document.AWSLink.split('.').pop()
                };
            });
        }
    },
    showAdd() {
      this.titleForm= "New Training";
      this.newGlobTraining = true;
      this.editTraining  = false;
    },

    deleteTraining(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this training?") &&
      this.trainingDelete(id);

    },

    trainingDelete(id) {
      axios.delete(`${url}/globalTraining/${id}`)
      .then((response) => {
        this.getTrainings();
        if (response.status == 400) {
          response.json().then(function(data) {
            return data.msg;
          });
        }
        this.msg=true;
        this.text="The training has been deleted successfully.";
      });
    },

    close() {
      this.dialog = false;
      this.uploadFile = null
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.newTraining= "";
        this.newLink = "";
        this.newDescription = "";
        this.newCategory = "";
        this.isPDF = false;
        this.newDocument = [];
      });
    },

    async updateTraining() {
      try {
        let req_body = {
          Training: this.newTraining,
          Link: this.newLink,
          Description: this.newDescription,
          Category: this.newCategory,
        };

        let formData = new FormData();

        for (let item in req_body) {
          formData.append(item, req_body[item]);
        }


        if(this.uploadFile != undefined) {
          Object.entries(this.uploadFile).forEach(([key, value]) => {
            formData.append('files', value);
          });
        }

        const response = await axios.put(`${url}/globalTraining/${this.trainingID}`, formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })

        this.msg = true;
        this.text = "The training has been updated successfully.";
        this.getTrainings();

      } catch (error) {
        console.log(error.response)
      }

      this.close();
    },

    getTrainings: function() {
      this.isLoading = true;
      axios.get(`${url}/globalTraining`).then(res => {
        this.trainings = res.data.trainings;
      }).finally(() => this.isLoading = false);
    },

    async addTraining() {

      try {
        let req_body = {
          Training: this.newTraining,
          Link: this.newLink,
          Description: this.newDescription,
          Category: this.newCategory
        };

        let formData = new FormData();

        for (let item in req_body) {
          formData.append(item, req_body[item]);
        }

        if(this.uploadFile != undefined) {
          Object.entries(this.uploadFile).forEach(([key, value]) => {
            formData.append('files', value);
          });
        }

        const response = await axios.post(`${url}/globalTraining`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })

        this.msg = true;
        this.text = "The new training has been added successfully.";
        this.getTrainings();

      } catch (error) {
        console.log(error.response)
      }

      this.close();
    },

    fileSelected(e) {
      this.uploadFile=e;
    },

    saveFile() {
      this.message = "";
      for (let i = 0; i < this.uploadFile.length; i++) {
        this.uploadFiles(this.uploadFile[i]);
      }
    },

    uploadFiles(file) {
      const formData = new FormData();
      formData.append('trainings', file);
      var ct = { headers:{"content-type" : "multipart/form-data"}};
      axios.post(`${url}/globalTraining/fileuploader/${this.trainingID}`,formData, ct)
      .then(res => {
        if(res){
          this.getTrainings();
        }
      })
      .catch(err => {
        console.log(err);
      });
    },

    deleteChip(index) {
      // Prompt here with text if required
      this.newDocument.splice(index, 1);
    },

    async loadPdf(url) {
      // Fetch an existing PDF document.
      const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const fDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
      document.getElementById('pdf').src = fDataUri;

    },
  },

};
</script>
